import _trTranslation from "./tr.json";
import _trApiTranslation from "./tr.api.json";

const translation = {
  ..._trTranslation,
  ..._trApiTranslation,
};

export default translation;
